module.exports = __webpack_public_path__ + "static/media/Plan.64c9cefb.png";